import { isJSXElement } from "@utils/common";

interface ContentParagraphProps {
    title?: string;
    content: string | string[] | JSX.Element;
}

export const ContentParagraph: React.FC<ContentParagraphProps> = ({ title, content }) => {
    return (
        <>
            {title && <h3 className="text-black text-xl font-semibold pb-5">{title}</h3>}
            {Array.isArray(content) ? (
                content.map((paragraph, index) => (
                    <p key={index} className="text-lg pb-6 text-left">
                        {paragraph}
                    </p>
                ))
            ) : isJSXElement(content) ? (
                content
            ) : (
                <p className="text-lg pb-6 text-left">{content}</p>
            )}
        </>
    );
};
